import {IHttpService} from "angular";
import {TfPayoffRequest} from "./PayoffRequests";
import {TfPayoffResponse} from "./PayoffResponses";

export class PayoffService {

    public static id = "payoffService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async tfCalculatePayoff(request: TfPayoffRequest): Promise<TfPayoffResponse> {
        const url = "/tradefloor/api/payoff/tf";
        const response = await this.$http.post<TfPayoffResponse>(url, request);
        return response.data!;
    }
}
